// Multi-factor authentication - see docs/extranet-mfa-react-contract.md
//
// For `factorer` and `web_interface` logins: after a correct password
// logins return the same pending response `{mfa_required, mfa_enrolled,
// user_type}` and the same full payload once stage 2 completes.
// `driver` logins are unaffected: `POST /login` still returns the full payload for them.

export const MFA_ENDPOINTS = {
  // Enrolment data (GET) and enrolment confirmation (POST). Both form-encoded.
  register: 'mfa/register',
  // Challenge. Form-encoded `totp_code`.
  verify: 'mfa/verify',
  // Email fallback send.
  email: 'mfa/email',
  // Email fallback consume. Token and obfuscated code travel in the URL path.
  emailVerify: 'mfa/email-verify',
};

// Response body is the same shape as every other extranet endpoint. `qr_uri`
// is a ready-to-use <img src> - render it directly, do not
// rebuild the provisioning URI from `secret` in the browser.
export const MFA_CODE_LENGTH = 6;

// Contract section 6. 1000/1021/1050 are pre-existing and live in Api.js.
export const MFA_ERRORS = {
  UNAUTHORISED: 1000,   // 401 - no (or expired) pending MFA session
  INVALID_LOGIN: 1021,  // 400 - bad password; now also disabled accounts
  INVALID_CODE: 1022,   // 400 - TOTP code invalid
  ALREADY_ENROLLED: 1023, // 400 - register hit by an enrolled + authenticated session
  EMAIL_FAILED: 1024,   // 400 - verification email failed to send
  EMAIL_LINK_INVALID: 1025, // 400 - link unknown / expired / already used
  UNENROLLED: 1026,     // 400 - verify hit by a not-yet-enrolled user
  LOCKED_OUT: 1027,     // 400 - too many failed attempts, try again later
  SECRET_UNREADABLE: 1028, // 500 - stored MFA secret could not be decrypted
};

// Minimal marker persisted so a page reload mid-flow can resume the MFA screen
// instead of dumping the user back at the password prompt. Deliberately holds
// nothing sensitive: no secret, no email, no user id - just what the server
// already told us in the login response. The server session stays the
// authority; if it is gone, the next MFA call returns 401/1000 and we bounce
// to sign-in.
export const MFA_PENDING_COOKIE = 'mfa_pending';

// Cookie paths / options kept identical to the existing `current_user` cookie.
export const MFA_COOKIE_OPTIONS = {path: '/'};